module.exports = __webpack_public_path__ + "static/media/ic-check-off.5b4add16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-check-off.svg
// module id = 387
// module chunks = 0